"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _APLogo = _interopRequireDefault(require("../../components/common/APLogo/APLogo"));
require("./StandAloneLayout.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var layoutClasses = (0, _cssClassesHelper.getBEMClasses)('standalone-layout');
var StandAloneLayout = function StandAloneLayout(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses('wrapper')
  }, /*#__PURE__*/_react["default"].createElement(_APLogo["default"], {
    customClass: layoutClasses('logo'),
    linkTo: "/"
  }), props.children);
};
var _default = exports["default"] = StandAloneLayout;